export const RESERVATION_ANALYTICS_EVENT_TYPES = [
  'page_view',
  'reservation_started',
  'reservation_completed',
] as const;

export type ReservationAnalyticsEventType = typeof RESERVATION_ANALYTICS_EVENT_TYPES[number];

export interface ReservationAnalyticsSession {
  sessionId: string;
  visitorId: string;
  expiresAt: number;
  lastSeenAt: number;
}

export interface ReservationAnalyticsContext {
  locale: string;
  language: string;
  /** Visitor/browser timezone. Keep this field's legacy meaning stable. */
  timezone: string;
  /** Canonical unit timezone, when the public settings projection is available. */
  unitTimezone?: string;
  screen: { width: number; height: number };
  viewport: { width: number; height: number };
  deviceType: 'mobile' | 'tablet' | 'desktop' | 'unknown';
  browser: string;
  operatingSystem: string;
  referrer: string | null;
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
}

export interface ReservationAnalyticsEvent {
  eventId: string;
  eventType: ReservationAnalyticsEventType;
  unitId: string;
  timestamp: string;
  sessionId: string;
  visitorId: string;
  locale: string;
  language: string;
  /** Visitor/browser timezone. Keep this field's legacy meaning stable. */
  timezone: string;
  /** Canonical unit timezone, when known at emit time. */
  unitTimezone?: string;
  screen: { width: number; height: number };
  viewport: { width: number; height: number };
  deviceType: 'mobile' | 'tablet' | 'desktop' | 'unknown';
  browser: string;
  operatingSystem: string;
  referrer: string | null;
  utm_source: string | null;
  utm_medium: string | null;
  utm_campaign: string | null;
  schemaVersion: 1;
}

export interface ReservationAnalyticsWriter {
  create(event: ReservationAnalyticsEvent): Promise<void>;
}
